<template>
  <v-card flat id="filtres-group">
    <v-card-text>
      <v-row align="center">
        <v-col cols="12" sm="3">
          <v-text-field
            label="Nom"
            single-line
            v-model="nameFilter"
            @keydown="clearTypingTimer"
            @keyup="triggerTypingTimer"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-select
            :items="versions"
            v-model="criteriaProxy.versions"
            label="Version"
            multiple
            chips
            clearable
            dense
            deletable-chips
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { defineComponent, computed, ref } from "@vue/composition-api";

export default defineComponent({
  props: {
    criteria: Object,
  },
  setup(props, { emit }) {
    /* Computed */
    const criteriaProxy = computed({
      get: function () {
        return props.criteria;
      },
      set: function (value) {
        emit("update:criteria", value);
      },
    });

    /* Variables */
    const versions = [
      { value: 0, text: "V2" },
      { value: 1, text: "V3" },
      { value: 2, text: "V4" },
      { value: 3, text: "V5" },
    ];
    let typingTimerId = 0;
    const debounceInterval = 500;
    const nameFilter = ref("");

    /* Méthodes */
    const triggerTypingTimer = function () {
      clearTimeout(typingTimerId);
      typingTimerId = setTimeout(function () {
        const terms = nameFilter.value.toLowerCase();
        criteriaProxy.value.name = terms;
        emit("update:criteria", criteriaProxy.value);
      }, debounceInterval);
    };
    const clearTypingTimer = function () {
      clearTimeout(typingTimerId);
    };

    return {
      criteriaProxy,
      versions,
      triggerTypingTimer,
      clearTypingTimer,
      nameFilter,
    };
  },
});
</script>
